import { isDoctorIdentity } from '../../../utils/telemedicine';

import { useRemoteParticipants, useTracks } from '@livekit/components-react';
import { Track } from 'livekit-client';
import { useEffect, useState } from 'react';

// Tempo que o médico tem, depois de entrar na sala, para publicar a câmera antes de o palco
// dizer que ela está desligada. O app publica os tracks só depois de conectar, então nos
// primeiros instantes ainda não há publicação nenhuma - e isso não é câmera desligada.
const CAMERA_PUBLISH_GRACE_MS = 5000;

/**
 * The doctor's camera, and whether it is switched off.
 *
 * Tells "camera off" (a muted publication, or none at all after the grace period) apart from
 * "on but not playing yet" (published but not subscribed) and from "just joined, not published
 * yet", so the stage only says the camera is off when it really is.
 */
const useDoctorCamera = () => {
	const cameras = useTracks([{ source: Track.Source.Camera, withPlaceholder: true }], { onlySubscribed: false });
	const remoteParticipants = useRemoteParticipants();

	const doctorParticipant = remoteParticipants.find(participant => isDoctorIdentity(participant.identity));
	const doctorSid = doctorParticipant?.sid;

	const [hasPublishGraceElapsed, setHasPublishGraceElapsed] = useState(false);

	// Recomeça a cada entrada do médico (o sid muda quando ele sai e volta).
	useEffect(() => {
		setHasPublishGraceElapsed(false);

		if (!doctorSid) {
			return undefined;
		}

		const timeout = setTimeout(() => setHasPublishGraceElapsed(true), CAMERA_PUBLISH_GRACE_MS);

		return () => clearTimeout(timeout);
	}, [doctorSid]);

	const doctorCamera = cameras.find(camera => isDoctorIdentity(camera.participant.identity));
	const publication = doctorCamera?.publication;

	const isDoctorCameraOn = !!publication && !publication.isMuted;
	const isDoctorCameraOff = publication ? publication.isMuted : hasPublishGraceElapsed;

	return {
		doctorCamera: isDoctorCameraOn && publication.track ? doctorCamera : null,
		isDoctorCameraOff
	};
};

export default useDoctorCamera;
